/**
 * A drug's dosage list is not keyed by rxcui (#664). Oracle's drug_options
 * returns Azelastine Hydrochloride's "137mcg/spray solution" and "0.1%
 * solution" under the same rxcui (1797867) with different package NDCs —
 * rxcui identifies a clinical concept, not a row in that list.
 *
 * Identify a dosage by its full strength/form signature instead. These are
 * exactly the fields the API round-trips (consults.serializers.DrugDosage),
 * so the dosage read back off a saved drug still matches its option in a
 * freshly fetched dosage list.
 */
export function dosageKey (dosage) {
    if (!dosage || !dosage.rxcui) {
        return null
    }
    return [dosage.rxcui, dosage.form, dosage.strength, dosage.strength_units].join('|')
}

/**
 * Index of `dosage` within `dosages`, or -1 when it isn't there. Callers
 * select a dosage by index because rxcui alone can't tell two of them
 * apart — see dosageKey().
 */
export function findDosageIndex (dosages, dosage) {
    const key = dosageKey(dosage)
    if (!key) {
        return -1
    }
    return (dosages || []).findIndex(dsg => dosageKey(dsg) === key)
}
